import {
  ERP_GET_VendorDashboard,
  ERP_Patch_VendorDashboard,
  
} from "../../../helpers/fakebackend_helper";
import { ERP_GET_Quotation } from '../../../helpers/fakebackend_helper';
import { GET_QUOTATION_DETAILS } from "../../../helpers/url_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const GET_VendorDashboard = createAsyncThunk(
  "vendorDashboard/get",
  async (thunkAPI) => {
    try {
      const response = ERP_GET_VendorDashboard();
      const data = await response;
 
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const PATCH_VendorDashboardData = createAsyncThunk(
  "vendorDashboard/patch",
  async (body, thunkAPI) => {
    try {
      if (!body) return;
       console.log(body);
       
      const response = await ERP_Patch_VendorDashboard(body);
      console.log(response);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const GET_RFQbyID = createAsyncThunk(
    'Quotation/get',
    async (VoucherID, thunkAPI) => {
        try {
            console.log('Fetching ticket details for VoucherID:', VoucherID);

            if (!VoucherID) {
                return thunkAPI.rejectWithValue('Voucher ID could not be extracted from the URL.');
            }

            // Call the API helper
            const api = GET_QUOTATION_DETAILS
            const param = VoucherID;
            const masterURL = `${api}${param}`;
            console.log(masterURL)
            const response = await ERP_GET_Quotation(masterURL);
            return response;

        } catch (error) {
            // Handle errors gracefully
            return thunkAPI.rejectWithValue(error.response?.data || error.message || 'Something went wrong');
        }
    }
);
const applyFilters = (existingData, filterArray) => {
  let result = existingData;

  if (filterArray.Accounts.length > 0) {
    result = result.filter((item) => filterArray.Accounts.includes(item.party));
  }

  return result;
};
